import ApplicationController from './application_controller'
import { basistheory } from '@basis-theory/web-elements'

export default class extends ApplicationController {
  static targets = [
    'form',
    'submitButton',
    'routingNumber',
    'accountNumber',
    'tokenId',
    'routingLastFour',
    'accountLastFour',
    'error'
  ]
  static values = { publicKey: String }

  async connect() {
    super.connect()
    try {
      this.bt = await basistheory(this.publicKeyValue)
      this.mountElements()
    } catch (error) {
      this.handleError(error)
    }
  }

  disconnect() {
    this.routingNumberElement = null
    this.accountNumberElement = null
  }

  async submit(event) {
    event.preventDefault()
    this.clearErrors()

    if (!this.bt) {
      this.showError('Bank form is still loading. Please wait and try again.')
      return
    }

    this.setSubmitting(true)

    try {
      const token = await this.bt.tokens.create({
        type: 'bank',
        data: {
          routing_number: this.routingNumberElement,
          account_number: this.accountNumberElement
        }
      })

      this.tokenIdTarget.value = token.id
      this.routingLastFourTarget.value = (token.data?.routing_number || '').slice(-4)
      this.accountLastFourTarget.value = (token.data?.account_number || '').slice(-4)
      this.formTarget.submit()
    } catch (error) {
      this.setSubmitting(false)
      if (error.data?.errors) {
        const messages = Object.values(error.data.errors).flat()
        this.showError(messages.join(', ') || 'Invalid bank details. Please check and try again.')
      } else {
        this.showError('Unable to securely process bank details. Please try again.')
      }
    }
  }

  // Private

  mountElements() {
    const inputStyle = {
      base: {
        fontSize: '14px',
        lineHeight: '1.5rem',
        padding: '0.5rem 0.75rem',
        width: '100%',
        color: '#1f2937',
        '::placeholder': {
          color: '#9ca3af'
        }
      }
    }

    this.routingNumberElement = this.bt.createElement('text', {
      targetId: 'bt-routing-number',
      placeholder: 'Routing Number (9 digits)',
      style: inputStyle,
      mask: [/\d/u, /\d/u, /\d/u, /\d/u, /\d/u, /\d/u, /\d/u, /\d/u, /\d/u]
    })

    this.accountNumberElement = this.bt.createElement('text', {
      targetId: 'bt-account-number',
      placeholder: 'Account Number',
      style: inputStyle
    })

    this.routingNumberElement.mount(this.routingNumberTarget)
    this.accountNumberElement.mount(this.accountNumberTarget)
  }

  setSubmitting(isSubmitting) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = isSubmitting
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove('hidden')
    }
  }

  clearErrors() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ''
      this.errorTarget.classList.add('hidden')
    }
  }
}
